// Click-to-copy strings (auto-merged by lib/i18n.ts).
export const en = {
  'copy.copy': 'Copy {value}',
  'copy.copied': 'Copied',
}

export const zhTW = {
  'copy.copy': '複製 {value}',
  'copy.copied': '已複製',
}
